import React from "react";
import { Component } from "react";
import pin from "views/profile/img/pin.png";
import imgdetails from "views/profile/img/timeline/imgdetails.png";
import logo from "views/profile/img/timeline/logo.png";
import pdf from "views/profile/img/timeline/pdf.png";
import { Chrono } from "react-chrono";
import applyjob from "views/profile/img/timeline/applyjob.png";
import { connect } from "react-redux";
import { getSingleApplicantInfoAction } from "store/Profile";
import { Link } from "react-router-dom";
import CheckValidateRoute from "CheckValidateRoute";

class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowDetails: true,
      jobs: this.props.Profile,
      value:[]
    };
  }

  async componentDidMount() {
 
  }
  render() {
   
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5 mt-4">
        <div className="flex justify-end items-center">
          <p className="w-5px h-5px rounded-full bg053C6D"></p>
          <p className="textE77817 fsize14 font-semibold pl-2">
            2 open threads
          </p>
        </div>
        <div className="lg:px-12 md:px-12 md:mt-0 md:mt-0 mt-4 pb-6">
          <div className="flex justify-center sm-chrono-pd0">
            {this.state.isShowDetails && (
              <div style={{ width: "850px", height: "750px" }}>
                <Chrono
                  mode={
                    window.innerWidth > 575
                      ? "VERTICAL_ALTERNATING"
                      : "VERTICAL"
                  }
                >
                   {this.state.jobs && this.state.jobs.Data && this.state.jobs.Data.JobData && this.state.jobs.Data.JobData.map((value, index) =>
                  (
                    <>
                      {value !== null ?  <>
                         
                          {value.hasOwnProperty("b_id")?<><div className="w-full pb-3">
                    <div className="flex justify-between px-4 py-2 rounded-4px bgF7F7F7 ">
                      <h4 className="fsize12 font-semibold text-black">
                        Bookmarked a Ticket
                      </h4>
                      <p className="text-black opacity-65 fsize12">
                        16th Jun 2021 
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="flex">
                        <div className="w-2/12">
                          <img
                            src={logo}
                            alt="image1"
                            className="w-39px h-30px"
                          />
                        </div>

                        <p className="fsize16  w-10/12	 font-semibold text-black">
                          {value.f_title}
                        </p>
                      </div>
                        {console.log()}

                      <div className="flex justify-between lg:mt-0 mt-0 lg:pl-0 pl-12">
                     
                        {" "}
                        <p className="text-black fsize14 lg:pl-14 md:pl-14">
                              
                                 {value.f_createdDate}
                        </p>
                        {/* <p
                          className="fsize12 font-semibold textE77817 underline"
                          onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                            })
                          }
                        >
                          View Details
                                </p> */}
                                   <Link
                            to={{
                              pathname:
                                process.env.PUBLIC_URL +
                                '/Career/profile'+'/'+
                                       value.f_id,
                              state:{value:value}
                                                                
                            }}
                                  className="fsize12 font-semibold textE77817 underline"
                                  onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                              value:value

                            })
                                    
                          }
                          >
                            View Details
                          </Link>
                      </div>
                    </div>
                  </div></>:""}


          {/* jobs HC*/}
          {value.hasOwnProperty("JobCode")?<><div className="w-full pb-3">
                              <div className="flex justify-between px-4 py-2 rounded-4px bgF7F7F7 ">
                      <h4 className="fsize12 font-semibold text-black">
                      Applied For Job
                      </h4>
                      <p className="text-black opacity-65 fsize12">
                        {value.JobAppliedDate}
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="flex">
                        <div className="w-2/12">
                          <img
                            src={logo}
                            alt="image1"
                            className="w-39px h-30px"
                          />
                        </div>

                        <p className="fsize16  w-10/12	 font-semibold text-black">
                          {value.JobTitle}
                        </p>
                      </div>
                        {console.log()}

                      <div className="flex justify-between lg:mt-0 mt-0 lg:pl-0 pl-12">
                     
                        {" "}
                        <p className="text-black fsize14 lg:pl-14 md:pl-14">
                              
                                 {value.Status}
                        </p>
                        {/* <p
                          className="fsize12 font-semibold textE77817 underline"
                          onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                            })
                          }
                        >
                          View Details
                                </p> */}
                                   <Link
                            to={{
                              pathname:
                                process.env.PUBLIC_URL +
                                '/Career/profile'+'/'+
                                       value.RID,
                              state:{value:value}
                                                                
                            }}
                                  className="fsize12 font-semibold textE77817 underline"
                                  onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                              value:value

                            })
                                    
                          }
                          >
                            View Details
                          </Link>
                      </div>
                    </div>
                  </div></>:""}

 {/* jobs MG*/}
 {value.hasOwnProperty("aj_jobId")?<><div className="w-full pb-3">
                              <div className="flex justify-between px-4 py-2 rounded-4px bgF7F7F7 ">
                      <h4 className="fsize12 font-semibold text-black">
                      Applied For Job
                      </h4>
                      <p className="text-black opacity-65 fsize12">
                        16th Jun 2021 
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="flex">
                        <div className="w-2/12">
                          <img
                            src={logo}
                            alt="image1"
                            className="w-39px h-30px"
                          />
                        </div>

                        <p className="fsize16  w-10/12	 font-semibold text-black">
                          {value.f_title}
                        </p>
                      </div>
                        {console.log()}

                      <div className="flex justify-between lg:mt-0 mt-0 lg:pl-0 pl-12">
                     
                        {" "}
                        <p className="text-black fsize14 lg:pl-14 md:pl-14">
                              
                                 {value.f_createdDate}
                        </p>
                        
                                   <Link
                            to={{
                              pathname:
                                process.env.PUBLIC_URL +
                                '/Career/profile'+'/'+
                                       value.f_id,
                              state:{value:value}
                                                                
                            }}
                                  className="fsize12 font-semibold textE77817 underline"
                                  onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                              value:value

                            })
                                    
                          }
                          >
                            View Details
                          </Link>
                      </div>
                    </div>
                  </div></>:""}

        {/* Signup MG*/}
      {value.hasOwnProperty("u_name")?<><div className="w-full pb-3">
                              <div className="flex justify-between px-4 py-2 rounded-4px bgF7F7F7 ">
                      <h4 className="fsize12 font-semibold text-black">
                      Signed Up On ICICI Careers Portal
                      </h4>
                      <p className="text-black opacity-65 fsize12">
                        16th Jun 2021 
                      </p>
                    </div>
                    <div className="mt-4">
                      <div className="flex">
                        <div className="w-2/12">
                          <img
                            src={logo}
                            alt="image1"
                            className="w-39px h-30px"
                          />
                        </div>

                        <p className="fsize16  w-10/12	 font-semibold text-black">
                          {value.f_title}
                        </p>
                      </div>
                        {console.log()}

                      <div className="flex justify-between lg:mt-0 mt-0 lg:pl-0 pl-12">
                     
                        {" "}
                        <p className="text-black fsize14 lg:pl-14 md:pl-14">
                              
                                 {value.f_createdDate}
                        </p>
                    
                                   <Link
                            to={{
                              pathname:
                                process.env.PUBLIC_URL +
                                '/Career/profile'+'/'+
                                       value.f_id,
                              state:{value:value}
                                                                
                            }}
                                  className="fsize12 font-semibold textE77817 underline"
                                  onClick={() =>
                            this.setState({
                              isShowDetails: !this.state.isShowDetails,
                              value:value

                            })
                                    
                          }
                          >
                            View Details
                          </Link>
                      </div>
                    </div>
                  </div></>:""}
                        </>
                      :""}
                    </>
                    
                        

                    )
                  )}
                 



                </Chrono>
              </div>
            )}
            {!this.state.isShowDetails && (
              
         <div className="lg:w-3/4 md:w-3/4 w-full">
                   
                <card className="rounded-sm drop-shadow20 bg-white block lg:px-8 md:px-8  px-4 pt-4 pb-12">
                  <div>
                    <div className="flex justify-between px-4 py-2 rounded-4px mx-4 bgF7F7F7 ">
                      <h4 className="fsize12 font-semibold text-black">
                        Raised a Ticket
                      </h4>
                      <div className="flex items-center">
                        <p className="text-black opacity-65 fsize12">
                          16th Jun 2021
                        </p>
                        <div class="flex items-center">
                          <span class="dot-point bg-bluecolor rounded-full mx-2"></span>
                          <p class="text-muted-400">11:49 AM</p>
                        </div>
                      </div>
                    </div>

                    <div className=" ">
                      <div className="lg:flex justify-between items-center mt-4 w-full">
                        <div className="flex lg:w-1/2 md:w-1/2 w-full items-center">
                          <img src={logo} alt="logo" />
                          <p className="text-black fsize16 pl-2 font-bold">
                            Response to a Ticket
                          </p>
                        </div>

                        <div className="lg:w-1/2 md:w-1/2 w-full lg:mt-0 mt-4 flex justify-between">
                          <div className="flex">
                            <p className="text-black fsize14">20th Jun 2021</p>
                            <div class="flex items-center">
                              <span class="dot-point bg-bluecolor rounded-full mx-2"></span>
                              <p class="text-muted-400">11:49 AM</p>
                            </div>
                          </div>

                          <p className="textE77817 underline cursor-pointer font-semibold fsize12">
                            Hide Details
                          </p>
                        </div>
                      </div>

                      <div class="divider-d8d8d8 mt-4 mb-8"></div>

                      <div className="lg:flex md:flex px-4">
                        <div className="lg:w-3/5  md:w-3/5 w-full lg:pr-4 md:pr-4">
                          <card className="rounded-sm   block ">
                            <p className="text-black font-bold fsize16">
                            {this.state.value? this.state.value.f_title? this.state.value.f_title :"":""}
                            </p>

                            <div>
                              <div className="flex justify-between items-center mt-2 w-1/2 mb-6">
                                <div className="flex items-center">
                                  <img src={pin} alt="map" />
                                  <p className="text074A7F fsize14 ml-2">
                                    {this.state.value? this.state.value.f_location? this.state.value.f_location :"":""}
                                  </p>
                                </div>
                                <p className="text-black opacity-50 fsize14">
                                  3d ago
                                </p>
                              </div>{" "}
                              {/* <p className="text-black fsize12 line-clamp-3 line-h20px"> */}
                                {this.state.value && this.state.value.f_description ? (
                            <p
                            className="text-black fsize12 line-clamp-3 line-h20px"
                              dangerouslySetInnerHTML={{
                                __html: decodeURIComponent(
                                  this.state.value.f_description
                                ),
                              }}
                            ></p>
                      ) : (
                        ""
                      )}{""}
                              {/* </p> */}
                              <div className="chips flex justify-between mt-10 lg:w-3/4 w-full md:w-3/4 mb-12 ">
                                <div className="bgE77820-trans rounded-21px p-10-17px">
                                  <p className="fsize11 opacity-100 textF06321 font-semibold">
                                    FULL TIME
                                  </p>
                                </div>
                                <div className="bgE77820-trans rounded-21px p-10-17px ">
                                  <p className="fsize11 font-semibold opacity-100 textF06321">
                                    2-5 YEARS
                                  </p>
                                </div>

                                <div className="bgE77820-trans rounded-21px p-10-17px">
                                  <p className="fsize11 font-semibold opacity-100 textF06321">
                                    COMMERICAL
                                  </p>
                                </div>
                              </div>
                            </div>
                          </card>
                        </div>

                        <div className="lg:w-2/5 md:w-2/5 w-full">
                          <div className="flex lg:justify-end justify-center">
                            <img src={imgdetails} className="w-257px h-228px" />
                          </div>
                        </div>
                      </div>

                      <div className="lg:mt-0 md:mt-0 mt-4">
                        <p className="text898989 fsize14">Attachments</p>
                        <div className="flex items-center mt-4">
                          <img src={pdf} alt="pdf" className="w-20px h-27px" />
                          <p className="text-black fsize16 font-semibold pl-3">
                            Resume.pdf
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </card>
              </div> 
            )}
          </div>
        </div>
      </card>

      
      
    );
  }
}

const mapStateToProps = (state) => {
  return {
    
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSingleApplicantInfoAction: async (payload) => {
      await dispatch(getSingleApplicantInfoAction(payload));
    },
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timeline);